<div id="loader" *ngIf="loader"><span class="spinner-border spinner-grow-lg"></span></div>

<div class="container my-4">
	<form (submit)="submit()">
		<div class="mb-3">
			<label for="number">Numer rezerwacji</label>
			<input type="number" class="form-control" id="number" name="number" [(ngModel)]="number" />
		</div>
		<button type="submit" class="btn btn-primary">Odśwież</button>
	</form>
</div>
